export const markNChars = (
  value: string | null | undefined = '',
  length = -4
) => {
  return `xxxx${(value || '').slice(length)}`;
};
